// extracted by mini-css-extract-plugin
export default {"errorBar":"ErrorBar_errorBar__1vl3o","icon":"ErrorBar_icon__KIFGN","text":"ErrorBar_text__6j4Uw"};